import aqe from '@pushly/aqe'
import { RuntimeConfig } from './runtime-config'

export function setupAqe(cfg: RuntimeConfig) {
    let storageDomain = cfg.PLATFORM_ROOT_DOMAIN
    let publicPlatformDomain = cfg.PUB_PLAT_URL
    let internalPlatformDomain = cfg.INT_PLAT_URL
    let publicApiDomain = cfg.PUB_API_URL
    let internalApiDomain = cfg.INT_API_URL
    let batchApiDomain = cfg.BATCH_API_URL
    let insightsDomain = cfg.INSIGHTS_URL

    // Dynamic resolution for preview sandboxes: <workspace>.<app>.<rootDomain>
    if (typeof window !== 'undefined' && window.location && window.location.hostname) {
        const parts = window.location.hostname.split('.')
        if (parts.length >= 4 && !parts.includes('local') && (parts[1] === 'platform' || parts[1] === 'halo')) {
            const sandboxId = parts[0]
            const rootDomain = parts.slice(2).join('.')
            storageDomain = rootDomain
            publicApiDomain = `${sandboxId}.api.${rootDomain}`
            internalApiDomain = `${sandboxId}.api.${rootDomain}`
            insightsDomain = `${sandboxId}.insights.${rootDomain}`
        }
    }

    aqe.set({
        appName: 'Pufferfish',
        storageDomain,
        publicPlatformDomain: `https://${publicPlatformDomain}`,
        internalPlatformDomain: `https://${internalPlatformDomain}`,
        publicApiDomain: `https://${publicApiDomain}`,
        internalApiDomain: `https://${internalApiDomain}`,
        batchApiDomain: `https://${batchApiDomain}`,
        insightsDomain: `https://${insightsDomain}`,
        publicCdnDomain: `https://${cfg.CDN_URL}`,
        publicMediaDomain: `https://${cfg.MEDIA_URL}`,
        preferencesNamespace: 'pufferfish',
    })
}
